<template>
  <div class="container-fluid min-vh-100">
    <div class="row min-vh-100">
      <!-- Coluna da Esquerda - Logo e benefícios -->
      <div class="col-md-6 d-none d-md-flex lc3-background-primary align-items-center justify-content-center">
        <div class="text-white px-5" style="max-width: 460px;">
          <img src="@/assets/logo.png" alt="AlugUp" class="img-logo mb-4">
          <h2 class="h3 fw-bold mb-3">Teste grátis por 7 dias</h2>
          <p class="mb-4 opacity-75">Todos os recursos liberados, sem cartão de crédito. Depois, é só escolher o período e pagar via Pix.</p>
          <ul class="list-unstyled mb-0">
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Vitrine online recebendo pedidos</li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Estoque com disponibilidade por data</li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Frete automático e roteiro de entregas</li>
            <li class="mb-2"><i class="bi bi-check-circle me-2"></i>Contrato digital assinado pelo celular</li>
          </ul>
        </div>
      </div>

      <!-- Coluna da Direita - Formulário -->
      <div class="col-md-6 d-flex align-items-center justify-content-center py-4">
        <div class="w-100" style="max-width: 420px;">
          <div class="card shadow-lg border-0">
            <div class="card-header lc3-background-primary text-white text-center py-4">
              <h2 class="card-title mb-0">
                <i class="bi bi-rocket-takeoff me-2"></i>Criar conta
              </h2>
              <small class="d-md-none">7 dias grátis, sem cartão</small>
            </div>

            <div class="card-body p-4">
              <form @submit.prevent="register">
                <div class="mb-3">
                  <label for="tenant_name" class="form-label">Nome da locadora</label>
                  <input v-model.trim="user.tenant_name" id="tenant_name" type="text" class="form-control" required maxlength="191" autocomplete="organization">
                </div>
                <div class="mb-3">
                  <label for="name" class="form-label">Seu nome</label>
                  <input v-model.trim="user.name" id="name" type="text" class="form-control" required maxlength="255" autocomplete="name">
                </div>
                <div class="mb-3">
                  <label for="phone" class="form-label">WhatsApp</label>
                  <input v-model.trim="user.phone" id="phone" type="tel" class="form-control" maxlength="20" placeholder="(79) 99999-9999" autocomplete="tel" inputmode="tel">
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label">E-mail</label>
                  <input v-model.trim="user.email" id="email" type="email" class="form-control" required autocomplete="email" placeholder="seu@email.com">
                </div>
                <div class="mb-4">
                  <label for="password" class="form-label">Senha</label>
                  <div class="input-group">
                    <input v-model="user.password" id="password" :type="showPassword ? 'text' : 'password'" class="form-control" required minlength="8" autocomplete="new-password" aria-describedby="passwordHelp">
                    <button class="btn btn-outline-secondary" type="button" @click="showPassword = !showPassword" :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'">
                      <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                    </button>
                  </div>
                  <div id="passwordHelp" class="form-text">Mínimo de 8 caracteres.</div>
                </div>

                <div class="d-grid mb-3">
                  <button type="submit" class="btn lc3-btn-primary btn-lg" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Começar teste grátis
                  </button>
                </div>

                <p class="text-center small mb-0">
                  Já tem conta? <router-link to="/login" class="fw-semibold">Entrar</router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/services/http.js';
import { reactive, ref } from 'vue';
import { useAuth } from '@/services/auth.js';
import router from '@/router';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';

export default {
  name: 'RegisterView',
  setup() {
    const auth = useAuth();
    const toastStore = useToastStore();
    const loading = ref(false);
    const showPassword = ref(false);

    const user = reactive({
      tenant_name: '',
      name: '',
      phone: '',
      email: '',
      password: ''
    });

    const register = async () => {
      loading.value = true;
      try {
        const { data } = await http.post('/register', { ...user, phone: user.phone || null });
        auth.forgetAdminSession();
        auth.setToken(data.token);
        auth.setUser(JSON.stringify(data.user));
        if (data.tenant) {
          auth.setTenant(JSON.stringify(data.tenant));
        }
        auth.setLastVerification(Date.now());
        toastStore.success('Conta criada! Seu teste grátis de 7 dias já começou.');
        router.push({ name: 'painel' });
      } catch (e) {
        toastStore.error('Não foi possível criar a conta: ' + parseError(e));
      }
      loading.value = false;
    };

    return { user, register, loading, showPassword };
  }
};
</script>

<style scoped>
.img-logo {
  width: 220px;
}
</style>
